import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { AlertCircle, Phone, Mail } from 'lucide-react';
export const Cancellation = () => {
  return <div className="min-h-screen bg-slate-50" style={{
    width: '100%'
  }} data-id="element-242">
      <Helmet data-id="element-243">
        <title data-id="element-244">Cancellation Policy | Taskpoint Appliance Repairs</title>
        <meta name="description" content="Understand your cancellation rights for appliance repair services. 14-day full refund policy for UK domestic appliance diagnostics and repairs." data-id="element-245" />
        <meta name="keywords" content="appliance repair cancellation, service cancellation policy, washing machine repair refund, UK appliance service terms, same-day appliance diagnostics UK" data-id="element-246" />
      </Helmet>
      <Header data-id="element-247" />
      <section className="py-20 bg-gradient-to-br from-teal-600 to-cyan-700 text-white" data-id="element-248">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-249">
          <h1 className="text-5xl font-bold mb-6" data-id="element-250">Cancellation Policy</h1>
          <p className="text-xl text-teal-50 max-w-3xl" data-id="element-251">
            Clear cancellation terms for our appliance repair services
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-252">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-253">
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12" data-id="element-254">
            <div className="mb-8" data-id="element-255">
              <h2 className="text-3xl font-bold text-slate-800 mb-6" data-id="element-256">
                Your Cancellation Rights
              </h2>
              <p className="text-slate-600 leading-relaxed mb-6" data-id="element-257">
                We offer flexible cancellation options for our repair services:
              </p>
              <div className="space-y-6" data-id="element-258">
                <div className="flex items-start space-x-4" data-id="element-259">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-260">
                    <span className="text-teal-600 font-bold text-lg" data-id="element-261">1</span>
                  </div>
                  <div data-id="element-262">
                    <h3 className="font-semibold text-slate-800 mb-2" data-id="element-263">
                      0–14 Days: Full Refund
                    </h3>
                    <p className="text-slate-600" data-id="element-264">
                      Cancel within 14 days of purchase for a full refund if no
                      work has been carried out.
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4" data-id="element-265">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-266">
                    <span className="text-teal-600 font-bold text-lg" data-id="element-267">2</span>
                  </div>
                  <div data-id="element-268">
                    <h3 className="font-semibold text-slate-800 mb-2" data-id="element-269">
                      15–28 Days: Partial Refund
                    </h3>
                    <p className="text-slate-600" data-id="element-270">
                      Cancellations between days 15–28 may receive a partial
                      refund at our discretion, depending on any work already
                      completed.
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4" data-id="element-271">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-272">
                    <span className="text-teal-600 font-bold text-lg" data-id="element-273">3</span>
                  </div>
                  <div data-id="element-274">
                    <h3 className="font-semibold text-slate-800 mb-2" data-id="element-275">
                      After 28 Days: No Refund
                    </h3>
                    <p className="text-slate-600" data-id="element-276">
                      Cancellations and refunds are not available after 28 days
                      from purchase.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-8" data-id="element-277">
              <h2 className="text-3xl font-bold text-slate-800 mb-6" data-id="element-278">
                How to Cancel Your Service
              </h2>
              <p className="text-slate-600 mb-6" data-id="element-279">
                To cancel your repair service, please contact us with your order
                details:
              </p>
              <div className="space-y-4" data-id="element-280">
                <div className="flex items-center space-x-3" data-id="element-281">
                  <Mail className="w-6 h-6 text-teal-600" data-id="element-282" />
                  <a href="mailto:Benjobalolong082@gmail.com" className="text-teal-600 hover:underline break-all" data-id="element-283">
                    Benjobalolong082@gmail.com
                  </a>
                </div>
                <div className="flex items-center space-x-3" data-id="element-284">
                  <Phone className="w-6 h-6 text-teal-600" data-id="element-285" />
                  <a href="tel:08000554969" className="text-teal-600 hover:underline text-lg font-semibold" data-id="element-286">
                    0800 055 4969
                  </a>
                </div>
              </div>
              <p className="text-slate-600 mt-6" data-id="element-287">
                All refunds are processed back to your original payment method.
              </p>
            </div>
            <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-lg" data-id="element-288">
              <div className="flex items-start space-x-3" data-id="element-289">
                <AlertCircle className="w-6 h-6 text-amber-600 flex-shrink-0 mt-1" data-id="element-290" />
                <div data-id="element-291">
                  <h3 className="font-semibold text-slate-800 mb-2" data-id="element-292">
                    Service Exclusions
                  </h3>
                  <p className="text-slate-600 mb-3" data-id="element-293">
                    Cancellations may not be eligible for refund in cases of:
                  </p>
                  <ul className="space-y-2 text-slate-600" data-id="element-294">
                    <li data-id="element-295">• Pre-existing faults identified before service</li>
                    <li data-id="element-296">• Misuse or neglect of the appliance</li>
                    <li data-id="element-297">• Unauthorised repair work by third parties</li>
                    <li data-id="element-298">• Non-standard modifications to the appliance</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-299" />
    </div>;
};